<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	name: "masterStasi",
	components: {},
	data() {
		return {
			info: {},
			currentPage: 1,
			totalPages: 0,
			loading: true,
			filters: {
				nama: { value: "", keys: ["nama"] },
				pelindung: { value: "", keys: ["pelindung"] },
				ketua: { value: "", keys: ["ketua"] },
				sekretaris: { value: "", keys: ["sekretaris"] },
				bendahara: { value: "", keys: ["bendahara"] },
			},
		};
	},
	created() {
		this.findAll();
	},
	mounted() {},
	computed: {
		...mapGetters({
			countAll: "masterStasi/countAll",
		}),
		...mapState({
			myData: (state) => state.masterStasi.data,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
		capital() {
			return (string) => string.charAt(0).toUpperCase() + string.slice(1);
		},
	},
	methods: {
		myFilter() {
			var d = new Date(this.filterDateValue);
			const filterDateValue = this.$moment(d).format("YYYY-MM-DD");

			switch (this.filterDate) {
				case "tanggal":
					this.filters.tanggal.value = filterDateValue;
					console.log("tanggal", filterDateValue);
					break;
				case "bulan":
					this.filters.tanggal.value = filterDateValue.slice(0, 7);
					console.log("bulan", filterDateValue.slice(0, 7));
					break;
				case "tahun":
					this.filters.tanggal.value = filterDateValue.slice(0, 4);
					console.log("tahun", filterDateValue.slice(0, 4));
					break;
				default:
					this.filters.tanggal.value = null;
					break;
			}
		},
		...mapActions({
			delete: "masterStasi/delete",
		}),
		findAll() {
			this.$store.dispatch("masterStasi/getAll");
		},
		refreshData() {
			this.findAll();
		},
		tambahData() {
			this.$router.push("/stasi/add");
		},
		getInfo(id) {
			this.info = this.$store.getters["masterStasi/getById"](id);
		},
		setEdit(id) {
			this.$router.push("/stasi/edit/" + id);
		},
		swalConfirm(id) {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				customClass: {
					confirmButton: "btn btn-danger m-1",
					cancelButton: "btn btn-secondary m-1",
				},
				confirmButtonText: "Ya, Hapus!",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					return this.delete(id).then(
						(response) => {
							return Promise.resolve(response.data);
						},
						(error) => {
							this.$swal("Gagal!", JSON.stringify(error), "danger");
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== "undefined") {
					if (result.value) {
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
		openModalFile(url) {
			this.$refs.modalfile.open();
			this.fileURL = url;
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Data Stasi/Lingkungan" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="spinner-border spinner-border-sm text-light"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
									<b-button
										v-b-toggle.collapse-filter
										variant="primary"
										size="sm"
										v-b-tooltip.hover
										title="Filter"
										><i class="fa fa-filter"></i
									></b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="tambahData()"
										v-b-tooltip.hover
										title="Delete"
										><i class="fa fa-plus"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>
				<!-- --------------------------- FILTER --------------------------- -->
				<b-collapse id="collapse-filter" class="mt-2">
					<div class="card-body pb-1 pt-1">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Nama Wilayah</label>
									<input
										v-model="filters.nama.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Pelindung</label>
									<input
										v-model="filters.pelindung.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Nama Ketua</label>
									<input
										v-model="filters.ketua.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
						</div>
						<hr />
					</div>
				</b-collapse>
				<!-- --------------------------- /FILTER --------------------------- -->

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<v-table
							class="table b-table table-vcenter table-striped table-bordered"
							:data="myData"
							:filters="filters"
							:currentPage.sync="currentPage"
							:pageSize="10"
							@totalPagesChanged="totalPages = $event"
						>
							<thead slot="head">
								<v-th
									sortKey="id"
									defaultSort="desc"
									class="text-center"
									>ID</v-th
								>
								<th>Nama</th>
								<th>Ketua</th>
								<th>Sekretaris</th>
								<th>Bendahara</th>
								<th class="text-center">Action</th>
							</thead>
							<tbody slot="body" slot-scope="{ displayData }">
								<tr v-for="item in displayData" :key="item.id">
									<td class="text-center">{{ item.id }}</td>
									<td>{{ capital(item.jenis) + ' ' + item.nama }}</td>
									<td>{{ item.ketua }}</td>
									<td>{{ item.sekretaris }}</td>
									<td>{{ item.bendahara }}</td>
									<td class="text-center">
										<b-btn-group>
											<b-button
												size="sm"
												variant="outline-dark"
												v-b-modal.modal-info
												@click="getInfo(item.id)"
												v-b-tooltip.hover
												title="Info"
											>
												<i class="fa fa-info"></i>
											</b-button>
											<b-button
												size="sm"
												variant="outline-dark"
												@click="setEdit(item.id)"
												v-b-tooltip.hover
												title="Edit"
											>
												<i class="fa fa-edit"></i>
											</b-button>
											<b-button
												size="sm"
												variant="danger"
												@click="swalConfirm(item.id)"
												v-b-tooltip.hover
												title="Delete"
											>
												<i class="fa fa-times"></i>
											</b-button>
										</b-btn-group>
									</td>
								</tr>

								<tr v-if="!displayData.length">
									<td colspan="100">
										<p class="text-center p-2">Tidak ada Data</p>
									</td>
								</tr>
							</tbody>
						</v-table>
						<smart-pagination
							:currentPage.sync="currentPage"
							:totalPages="totalPages"
						/>
					</template>
				</div>
			</div>
		</div>

		<b-modal id="modal-info" hide-footer size="lg" title="Informasi Wilayah">
			<table class="table">
				<tbody>
					<tr>
						<td>Nama Wilayah</td>
						<td>:</td>
						<td>{{ this.info.nama }}</td>
					</tr>
					<tr>
						<td>Pelindung</td>
						<td>:</td>
						<td>{{ this.info.pelindung }}</td>
					</tr>
					<tr>
						<td>Nama Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua }}</td>
					</tr>
					<tr>
						<td>No. HP Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Ketua</td>
						<td>:</td>
						<td>{{ this.info.ketua_alamat }}</td>
					</tr>
					<tr>
						<td>Nama Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris }}</td>
					</tr>
					<tr>
						<td>No. HP Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Sekretaris</td>
						<td>:</td>
						<td>{{ this.info.sekretaris_alamat }}</td>
					</tr>
					<tr>
						<td>Nama Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara }}</td>
					</tr>
					<tr>
						<td>No. HP Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara_nohp }}</td>
					</tr>
					<tr>
						<td>Alamat Bendahara</td>
						<td>:</td>
						<td>{{ this.info.bendahara_alamat }}</td>
					</tr>
				</tbody>
			</table>
		</b-modal>
	</div>
</template>

<style scoped>
nav.smart-pagination {
	margin-top: 20px;
}
</style>